const searchSettings = {
    firstSearch: true,
    page: 1,
    keywords: new URLSearchParams(window.location.search).get("keywords")
};

document.addEventListener('DOMContentLoaded', function() {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
        if (entry.isIntersecting) {
            if (searchSettings.keywords != null && searchSettings.keywords.length > 0) {
                $('.search-results-form input[name="keywords"]').val(searchSettings.keywords);
                getSearchProducts();
            }
            // 不再取消观察，保留观察以便下次再次触发
            // observer.unobserve(entry.target);
        }
    });
    }, {
        threshold: 1,
        rootMargin: '10px'
    });

    const testingElement = document.querySelector('.page-search-results-loading');
    if (testingElement) observer.observe(testingElement);

    eachBoxQtyHTML = '<div class="search-list-item-qty">'+
                        '<div class="search-list-item-qty-box">'+
                        '<div class="search-list-item-qty-input">'+
                            '<div class="search-list-item-qty-input-minus">'+
                            '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">'+
                                '<path d="M8.5 15.5h-1V.5h1z" style="fill-rule:evenodd"></path>'+
                            '</svg>'+
                            '</div>'+
                            '<input type="text" name="quantity" value="1" class="search-list-item-qty-input-field search-list-item-qty-input-field_each" data-id="{[eachID]}">'+
                            '<div class="search-list-item-qty-input-plus">'+
                            '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">'+
                                '<defs><style>.cls-1{fill-rule:evenodd}</style></defs><path class="cls-1" d="M.5 8.5v-1h15v1z"></path><path class="cls-1" d="M8.5 15.5h-1V.5h1z"></path>'+
                            '</svg>'+
                            '</div>'+
                        '</div>'+
                        '<div class="search-list-item-qty-info">'+
                            '<div class="search-list-item-qty-info-value">'+
                            '<span class="search-list-item-qty-info-price">{[eachPrice]}</span>'+
                            '<span class="search-list-item-qty-info-label">each</span>'+
                            '</div>'+
                        '</div>'+
                        '</div>'+
                        '<div class="search-list-item-qty-box search-list-item-qty-box_box">'+
                        '<div class="search-list-item-qty-input">'+
                            '<div class="search-list-item-qty-input-minus">'+
                            '<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">'+
                                '<path d="M8.5 15.5h-1V.5h1z" style="fill-rule:evenodd"></path>'+
                            '</svg>'+
                            '</div>'+
                            '<input type="text" name="quantity" value="0" class="search-list-item-qty-input-field search-list-item-qty-input-field_box" data-id="{[boxID]}">'+
                            '<div class="search-list-item-qty-input-plus">'+
                            '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">'+
                                '<defs><style>.cls-1{fill-rule:evenodd}</style></defs><path class="cls-1" d="M.5 8.5v-1h15v1z"></path><path class="cls-1" d="M8.5 15.5h-1V.5h1z"></path>'+
                            '</svg>'+
                            '</div>'+
                        '</div>'+
                        '<div class="search-list-item-qty-info">'+
                            '<div class="search-list-item-qty-info-label">{[boxLabel]}</div>'+
                            '<div class="search-list-item-qty-info-value">'+
                            '<span class="search-list-item-qty-info-price">{[boxPrice]}</span>'+
                            '<span class="search-list-item-qty-info-label">each</span>'+
                            '</div>'+
                        '</div>'+
                        '</div>'+
                    '</div>'+
                    '<div class="search-list-item-note">BOX UP & SAVE 5%</div>'+
                    '<div class="search-list-item-addcart button">'+
                        '<div class="button-text">'+
                        '<i><svg class="svg-cart" width="32" height="32" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"><use xlink:href="#svg-cart"></use></svg></i>'+
                        '<span>Add to Cart</span>'+
                        '</div>'+
                        '<div class="button-loading"><div><i></i></div></div>'+
                    '</div>';

    function getSearchProducts() {
        $.ajax({
            type: "GET",
            data: 'q=' + encodeURIComponent(searchSettings.keywords) + '&firstSearch=' + (searchSettings.firstSearch ? 1 : 0) + '&page='+searchSettings.page,
            url: 'https://app.plumbingsell.com/api/60722970760/search/search',
            dataType: "json",
            beforeSend: function(){
                $('.page-search-results-loading').removeClass('hide');
            },
            success: function(response){
                if (response.status) {
                    if (response.data.total == 0) {
                        $('.page_title').text('Your search for “' + searchSettings.keywords + '” did not yield any results.');
                        observer.unobserve(testingElement);
                    } else {
                        $('.page_title').text(response.data.total+' RESULTS FOR “' + searchSettings.keywords + '”');

                        for (i in response.data.products) {
                            let product = response.data.products[i];
                            let imgUrl = product.featuredMedia.replace(/(\.(jpg|png|webp|gif|bmp))(\?v=.*)?$/, '_560x$1$3');

                            // 判断variants是否为each和box的2个组合
                            let isEachBox = false;
                            let thisEachBoxQtyHTML = eachBoxQtyHTML;
                            if (product.variants.length === 2) {
                                const titles = product.variants.map(v => v.title.trim().toLowerCase());
                                if (titles.includes('each') && titles.includes('box')) {
                                    isEachBox = true;
                                }
                            }
                            if (isEachBox) {
                                for (vi in product.variants) {
                                let title = product.variants[vi].title.trim().toLowerCase();
                                if (title == 'each') {
                                    thisEachBoxQtyHTML = thisEachBoxQtyHTML.replace("{[eachID]}", product.variants[vi].id);
                                    eachPrice = product.variants[vi].price;
                                    thisEachBoxQtyHTML = thisEachBoxQtyHTML.replace("{[eachPrice]}", formatMoney(product.variants[vi].price*100));
                                    continue;
                                }
                                if (title == 'box') {
                                    thisEachBoxQtyHTML = thisEachBoxQtyHTML.replace("{[boxID]}", product.variants[vi].id);
                                    thisEachBoxQtyHTML = thisEachBoxQtyHTML.replace("{[boxLabel]}", formatMoney(product.variants[vi].price*100)+' box of '+product.box_quantity);
                                    thisEachBoxQtyHTML = thisEachBoxQtyHTML.replace("{[boxPrice]}", formatMoney(product.variants[vi].price/product.box_quantity*100));
                                }
                                }
                            } else {
                                thisEachBoxQtyHTML = '';

                                if (product.variants.length > 1) {
                                    thisEachBoxQtyHTML += '<div class="search-list-item-more">'+product.variants.length+' Options - <a href="/products/'+product.handle+'" target="_blank">View More</a></div>';
                                }

                                let firstVariant = product.variants[0];
                                for (vi in product.variants) {
                                    if (product.variants[vi].availableForSale) {
                                        let firstVariant = product.variants[vi];
                                        break;
                                    }
                                }
                                thisEachBoxQtyHTML += '<div class="search-list-item-noeachbox">';
                                if (firstVariant.compareAtPrice > firstVariant.price) {
                                thisEachBoxQtyHTML += '<div class="search-list-item-noeachbox-price">'+
                                                        '<span class="search-list-item-noeachbox-price-now">'+formatMoney(firstVariant.price*100)+'</span>'+
                                                        '<span class="search-list-item-noeachbox-price-retail">'+formatMoney(firstVariant.compareAtPrice*100)+'</span>'+
                                                        '</div>';
                                } else {
                                thisEachBoxQtyHTML += '<div class="search-list-item-noeachbox-price">'+
                                                        '<span class="search-list-item-noeachbox-price-now">'+formatMoney(firstVariant.price*100)+'</span>'+
                                                        '</div>';
                                }
                                thisEachBoxQtyHTML += '<div class="search-list-item-noeachboxaddcart button" data-id="'+firstVariant.id+'">'+
                                                        '<div class="button-text">'+
                                                        '<i><svg class="svg-cart" width="32" height="32" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.002 512.002" style="enable-background:new 0 0 512.002 512.002;" xml:space="preserve"><use xlink:href="#svg-cart"></use></svg></i>'+
                                                        '</div>'+
                                                        '<div class="button-loading"><div><i></i></div></div>'+
                                                    '</div>';
                                thisEachBoxQtyHTML += '</div>'
                            }
                        

                            let productHTML = '<li class="search-list-item product-card">'+
                                        '<a href="/products/'+product.handle+'" class="search-list-item-top" target="_blank">'+
                                        '<div class="search-list-item-image">'+
                                            '<img src="'+imgUrl+'" />'+
                                        '</div>'+
                                        '</a>'+
                                        '<div class="featured_product-overlay overlay-ui multi-button-overlay search-list-item-overlay">'+
                                            '<button type="button" class="btn btn-quick-shop js-quick-shop rainred-js-quick-shop" data-product-handle="pex-crimp-ball-valve-lead-free-pick-size-to-add"><svg width="24px" height="24px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="eye" class="svg-eyes" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path></svg><svg class="svg-loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; shape-rendering: auto;" width="28px" height="28px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><circle cx="50" cy="50" fill="none" stroke="#fdb819" stroke-width="5" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg></button>'+
                                        '</div>'+
                                        '<div class="search-list-item-info">'+
                                        '<a href="/collections/vendors?q=EFIELD" class="search-list-item-vendor">EFIELD</a>'+
                                        '<h3 class="search-list-item-title">'+product.title+'</h3>'+thisEachBoxQtyHTML+
                                        '</div>'+
                                    '</li>';

                            $('.search-list').append(productHTML);
                        }

                        if (response.data.pageCurrent < response.data.pageTotal) {
                            searchSettings.firstSearch = false;
                            searchSettings.keywords = response.data.keywords;
                            searchSettings.page = Number(response.data.pageCurrent) + 1;
                        } else {
                            observer.unobserve(testingElement);
                        }
                    }

                } else {
                    observer.unobserve(testingElement);
                }

                $('.page-search-results-loading').addClass('hide');
            },
            error: function(){
                observer.unobserve(testingElement);
                $('.page-search-results-loading').addClass('hide');
            }
        });
    }

});

$(document).ready(function() {
    // 点击 + 按钮
    $('body').on('click', '.search-list-item-qty-input-plus', function() {
        let input = $(this).siblings('input');
        let val = parseInt(input.val()) || 0;
        input.val(val + 1);
    });

    // 点击 - 按钮
    $('body').on('click', '.search-list-item-qty-input-minus', function() {
        let input = $(this).siblings('input');
        let val = parseInt(input.val()) || 0;
        if (val > 0) {
        input.val(val - 1);
        }
    });

    // 限制输入只能为整数（不允许小数点或非数字）
    $('body').on('input', '.search-list-item-qty-input-field', function() {
        let val = $(this).val().replace(/[^0-9]/g, ''); // 移除非数字
        $(this).val(val);
    });

    // search-list-item-noeachboxaddcart
    $('body').on('click', '.search-list-item-noeachboxaddcart .button-text', function() {
        let thisBtn = $(this).parent();

        let formData = {
            'items': []
        };

        let thisID = thisBtn.attr('data-id');
        formData.items.push({'id': thisID, 'quantity': 1});

        $.ajax({
            type: "POST",
            url: cart_add_url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(formData),
            dataType: "json",
            beforeSend: function(){
                thisBtn.children(".button-loading").show();
            },
            success: function(response){
                thisBtn.children(".button-loading").hide();
                openCart();
            },
            error: function(xhr, status, error){
                const errorJson = JSON.parse(xhr.responseText);
                alert(errorJson.message);
                thisBtn.children(".button-loading").hide();
            }
        });
    })

    // search-list-item-noeachboxaddcart
    $('body').on('click', '.search-list-item-addcart .button-text', function() {
        let thisBtn = $(this).parent();

        let formData = {
            'items': []
        };

        let thisEach = thisBtn.parent().find('.search-list-item-qty-input-field_each');
        if (thisEach.val() > 0) {
            formData.items.push({'id': thisEach.attr('data-id'), 'quantity': thisEach.val()});
        }

        let thisBox = thisBtn.parent().find('.search-list-item-qty-input-field_box');
        if (thisBox.val() > 0) {
            formData.items.push({'id': thisBox.attr('data-id'), 'quantity': thisBox.val()});
        }
        

        $.ajax({
            type: "POST",
            url: cart_add_url,
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(formData),
            dataType: "json",
            beforeSend: function(){
                thisBtn.children(".button-loading").show();
            },
            success: function(response){
                thisBtn.children(".button-loading").hide();
                openCart();
            },
            error: function(xhr, status, error){
                const errorJson = JSON.parse(xhr.responseText);
                alert(errorJson.message);
                thisBtn.children(".button-loading").hide();
            }
        });
    })

});